module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/zh-hant_4-e20bf7b900e1f080004ff3c5cad96131.jpg";